import { format } from 'date-fns';
import User from './User';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Fields = ({fields, data, show_icons = false, wrapper_class = "py-3", update = false}) => {
    const numberWithSpaces = (x) => {
        if (x) {
            var parts = x.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
        }
    }

    const formatUrl = (url) => {
        let formattedUrl = url;

        // Vérifier si l'URL commence par "http://" ou "https://"
        if (!formattedUrl.startsWith("http://") && !formattedUrl.startsWith("https://")) {
            formattedUrl = "https://" + formattedUrl;
        }
    
        // Vérifier si l'URL ne commence pas par "www."
        if (!formattedUrl.startsWith("www.")) {
            // Extraire le domaine de l'URL
            const domain = formattedUrl.split('//')[1].split('/')[0];
            // Vérifier si le domaine ne contient pas de sous-domaine et a une extension de domaine
            if (!domain.includes(".") && domain.split(".").length > 1) {
                // Si le domaine ne contient pas de sous-domaine mais a une extension de domaine, ajouter "www."
                formattedUrl = formattedUrl.replace(domain, "www." + domain);
            }
        }
    
        return (
            <a href={formattedUrl} target="_blank" className="btn-link">
                {url}
            </a>
        );    
    }

    const formatPhoneNumber = (phoneNumber) => {
        // Suppression de tous les caractères non numériques
        let cleaned = ('' + phoneNumber).replace(/\D/g, '');
    
        // Ajout des espaces tous les deux chiffres pour le format français
        let match = cleaned.match(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/);
    
        // Si le format correspond, on reformate, sinon on retourne le numéro nettoyé
        return (match) ? `${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}` : cleaned;
    }

    const getNestedValue = (obj, key) => {
        return key.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
    };
    // console.log(data);

    const formatValue = (value, key, element, field) => {
        // si un format est renseigné, on formatte
        switch (field.format) {
            case 'date':
            case 'date_timestamp':
                let date;
                if (field.format == 'date_timestamp') {
                    date = new Date(element[key] * 1000)
                }
                else {
                    date = new Date(element[key])
                }

                let date_format = field.date_format ?? 'dd/MM/yyyy'

                if (!isNaN(date)) {
                    value = date ? format(date, date_format) : '';                    
                }
                break;
            
            case 'money':
                value = numberWithSpaces(parseFloat(value).toFixed(2)) + ' €';
                break;

            case 'bool':
                value = value == 1 ? (<span className="text-mlime font-bold">Oui</span>) : (<span className="text-morange font-bold">Non</span>);
                break;

            case 'url':
                value = formatUrl(value);
                break;
            
            case 'phone':
                value = formatPhoneNumber(value);
                break;

            case 'user':
                value = (<User user={value} size="42" />)
                wrapper_class += " user-field"
                break;

            case 'rdv': 
                value = <>
                    <div><i class="fa-solid fa-users"></i> {format(value.date, 'dd/MM/yyyy')}</div>
                </>
                break;
        
            default:
                break;
        }
        return value;
    }

    const displayField = (field, element) => {
        
        if (!field || typeof field !== 'object' || !field.name) return null;

        let key = field.single_key ?? field.key;
        let field_name = field.name;
        let value = getNestedValue(element, key); 
        if (field.value !== undefined) {
            value = field.value;
        }

        let updated_value = false;

        console.log(field, element, key, value);
    
        // if (typeof value === 'object' && value !== null) {
        //     //  propriété 'title'
        //     if (value.title) {
        //         value = value.title; 
        //     } else {
        //         value = JSON.stringify(value); 
        //     }
        // }


        if (update) {
            let new_value = false;
            if (field.single_key) {
                let el = update[field.key].find((e) => e.id == element.id)
                if (el) {
                    new_value = getNestedValue(el, key)                    
                }
            }
            else {
                new_value = getNestedValue(update, key)
            }
            
            if (new_value != value) {
                updated_value = new_value
            }
        }
        

        if (!value) {
            return false;
        }
        
        // suivant le field, on formatte la value
        switch (field.key) {

            case 'phones':
            case 'ndd':
                field_name = element.libelle_name;
                break;
            
            case 'type_site':
                value = value.charAt(0).toUpperCase() + value.slice(1) + (value == 'vitrine' && data.type_vitrine ? ' - Type ' + data.type_vitrine : "");
                break;

            case 'type_contrat_id':
                value = (data?.type_contrat && data.type_contrat.name) ? data.type_contrat.name : "Type inconnu";
                break;
        
            case 'etat_id':
                let colors = {
                    1: 'mlime',
                    2: 'red-600',
                    3: 'red-600',
                    4: 'cyan-400',
                }
                const etatName = data?.etat_contrat?.name ?? "État inconnu";
                const etatColor = colors[value] ?? 'gray-500';

                value = (<span className={`text-${etatColor} font-bold`}>{etatName}</span>)

                // Rendu personnalisé pour le champ "État"
                return (
                    <div key={key}>
                        <div className="font-bold text-mdark text-[16px]">{field_name}</div>
                        <div className={`text-gray-900 order-1 text-sm ${updated_value ? 'line-through' : ''}`}>{value}</div>
                        {updated_value && (
                            <div className="font-bold text-mdark text-sm text-morange">{updated_value}</div> 
                        )}
                    </div>
                );

                break;
            
            case 'agence':
                value = data.agence.name.replace('Agence de', '');
                break;
            
            case 'partenariat':

                value = <>
                    {value.date_signature && (
                        <div>Signé le {format(value.date_signature, 'dd/MM/yyyy')}</div>
                    )}
                    {value.date_signature_pv && (
                        <div className="text-mlime font-bold">Signature PV le {format(value.date_signature_pv, 'dd/MM/yyyy')}</div>                
                    )}
                </>
                break;

            case 'maquette':
            case 'dev':
            case 'ref':
            case 'mel':
                let color = ''
                if (value.status == 1) {
                    color = 'text-mlime';
                }
                else if (value.status == 0) {
                    color = 'text-morange';
                }

                // if (value.status == 1 && field.key == 'maquette' && value.task && typeof value.task_prefix == 'undefined') {
                    
                //     value.task_prefix = value.task_txt
                //     value.task_txt = 'Validée le ' + format(new Date(value.task.created_at), 'dd/MM/yyyy à HH:mm')
                    
                // }
                    
                value = <>
                    {value.task_prefix && (
                        <div>{value.task_prefix}</div>
                    )}
                    <div className={`${color} font-bold`}>{value.task_txt}</div>
                </>
                break;

            case 'date':
                value = '<i class="fa-solid fa-users"></i> Rendez-vous le ' + format(new Date(value.date), 'dd/MM/yyyy à HH:mm'); // Formatage de la date
            break;

            default:
                break;
        }

        value = formatValue(value, key, element, field);

        if (updated_value) {
            updated_value = formatValue(updated_value, key, element, field);
        }
        if (field.invert && field.invert == 1) {
            let tmp = field_name
            field_name = value
            value = tmp
        }

        if (field.suffix) {
            value = (<span>{value} <sup>{field.suffix}</sup></span>)
        }

        if (Array.isArray(value)) {

            value = (
                <>
                    {value.map((item, index) => (
                        <React.Fragment key={index}>
                            {item}
                            {index !== value.length - 1 ? <br /> : null}
                        </React.Fragment>
                    ))}
                </>
            );
        }

        let icon;
        if (show_icons) {
            if (React.isValidElement(field.icon)) {
                icon = field.icon
            } else if (typeof field.icon === 'object' && !React.isValidElement(field.icon)) {
                icon = field.icon[element.libelle]
            }
        }
        console.log(value);
        return  <div className={`${wrapper_class} flex items-center gap-3 ${field.classes ?? ''} `}>
            {show_icons && (
                <div className=" text-xl text-mlime w-6 text-center">
                    {icon}
                </div>
            )}
            <div>
                <div className="font-bold text-mdark text-[16px]">{field_name}</div>
                <div className={`text-gray-900 order-1 text-sm ${updated_value ? 'line-through' : ''}`}>{value}</div> 
                {updated_value && (
                    <div className="font-bold text-mdark text-sm text-morange">{updated_value}</div> 
                )}       
            </div>
        </div>
    };

    return (
        <>
            <div className="">
                <div className="divide-y divide-mgray text-sm">                
                    {fields.map((field, index) => (
                        <React.Fragment key={index}>

                            {(() => {
                                // Vérifie si la clé est 'mails' ou 'phones'
                                if (['mails', 'phones', 'ndd'].includes(field.key)) {
                                    // Si c'est le cas, itère sur les mails et les affiche
                                    // return data[field.key].map((element, index) => (
                                    //     displayField(field, element)
                                    // ));
                                    const list = Array.isArray(data[field.key]) ? data[field.key] : [];
                                    return list.map((element, index) => (
                                        <React.Fragment key={index}>
                                            {displayField(field, element)}
                                        </React.Fragment>
                                    ));
                                } else {
                                    if (update) {
                                        // return displayField(field, update)
                                    }
                                    // Sinon, affiche la valeur normalement
                                    return displayField(field, data)
                                }
                            })()}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </>

    )
}

export default Fields;
